import { render, staticRenderFns } from "./AppViewEvent.vue?vue&type=template&id=1b122ca8&scoped=true"
import script from "./AppViewEvent.vue?vue&type=script&lang=js"
export * from "./AppViewEvent.vue?vue&type=script&lang=js"
import style0 from "./AppViewEvent.vue?vue&type=style&index=0&id=1b122ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b122ca8",
  null
  
)

export default component.exports